import React from 'react';

const Champ = () => {
  return <div style={{ height: '800px' }}>champ</div>;
};

export default Champ;
